import gql from 'graphql-tag';

export default gql`
query CheckGroupSlugExists($groupSlug: String!) {
  checkGroupSlugExists(object: { groupSlug: $groupSlug })
}
`;
